import { ReactNode } from 'react';
import cx from 'classnames';
import { IconButton, Icon } from '@intellecteu/common-ui';
import Logo from 'app/assets/images/logo.svg';
import LogoSmall from 'app/assets/images/logo_small.svg';

import s from './styles.module.scss';

interface ILayoutSidebar {
  collapsed: boolean;
  children?: ReactNode;
  sidebarToggle: () => void;
}

const Sidebar = ({ collapsed, children, sidebarToggle, ...props }: ILayoutSidebar) => (
  <div className={cx(s.sidebar, collapsed && s.sidebarCollapsed)} {...props}>
    <div className={collapsed ? s.sidebarColumn : s.sidebarContainer}>
      {collapsed ? (
        <LogoSmall className={cx(s.sidebarLogo, s.sidebarLogoSmall)} />
      ) : (
        <Logo className={cx(s.sidebarLogo)} />
      )}
      <IconButton
        onClick={sidebarToggle}
        className={cx(s.sidebarArrow, collapsed ? s.sidebarArrowCollapsed : s.sidebarArrowInline)}
        iconName={Icon.icons.arrowLeft}
        id="header__hide-sidebar"
        iconClassName={s.sidebarArrowIcon}
        showHover={false}
      />
    </div>
    {children}
  </div>
);

export default Sidebar;
